import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import Layout from "../../../layout/layout";
import AppBannerList from "./appBannerList";
import BannerFormDialog from "./bannerFormDialog";

// Placeholder page for managing app banners; extend with data fetching and forms
const AppBannerManagement = () => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    // const [isAuthenticated, setIsAuthenticated] = useState(false);

    // useEffect(() => {
    //     const password = prompt("Enter password to access this page:");
    //     if (password === "admin123") {
    //         setIsAuthenticated(true);
    //     } else {
    //         alert("Incorrect password. Access denied.");
    //         window.history.back();
    //     }
    // }, []);

    const handleCreateClick = () => {
        setDialogOpen(true);
    };

    const handleCloseDialog = () => {
        setDialogOpen(false);
    };

    const handleSuccess = () => {
        setRefreshTrigger(prev => prev + 1);
    };

    // if (!isAuthenticated) {
    //     return null;
    // }

    const body = (
        <div>
            <div style={{ marginBottom: "16px", display: "flex", justifyContent: "flex-end" }}>
                <Button variant="contained" color="primary" onClick={handleCreateClick}>
                    Create New Banner
                </Button>
            </div>
            <AppBannerList refreshTrigger={refreshTrigger} />
            <BannerFormDialog
                open={dialogOpen}
                onClose={handleCloseDialog}
                banner={null}
                onSuccess={handleSuccess}
            />
        </div>
    );
    return <Layout body={body} />;
};

export default AppBannerManagement;
